import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
} from '@mui/material';

const FinancialIncome = () => {
    const initialRows = [
        { id: 'income1', label: 'Income Source 1', values: [0, 0, 0] },
    ];

    const [rows, setRows] = useState(initialRows);

    const handleValueChange = (rowIndex, colIndex, value) => {
        
    };

    const addNewRow = () => {
        const newRow = { id: `${rows.length + 1}`, label: `${rows.length + 1}`, values: [0, 0, 0] };
        setRows([...rows, newRow]);
    };

    const calculateRowTotal = (values) => {
        return values.reduce((acc, curr) => acc + curr, 0);
    };

    const calculateColumnTotal = (colIndex) => {
        return rows.reduce((acc, row) => acc + row.values[colIndex], 0);
    };

    return (
        <div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            {["Ürün Kalemi", "Satış Fiyatı", "Doğrudan Maliyet"].map((text) => (
                                <TableCell key={text} align="right">{text}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, rowIndex) => (
                            <TableRow
                                key={row.id}
                                sx={{
                                    '&:last-child td, &:last-child th': { border: 0 },
                                    backgroundColor: row.isTotal ? '#f5f5f5' : 'inherit'
                                }}
                            >
                              
                                {row.values.map((value, colIndex) => (
                                    <TableCell key={colIndex} align="right">
                                        <TextField
                                            type="text"
                                            onChange={(e) => handleValueChange(rowIndex, colIndex, e.target.value)}
                                            size="small"
                                            inputProps={{ style: { textAlign: 'right', maxWidth: '100px' } }}
                                        />
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Button variant="contained" color="primary" onClick={addNewRow}>
                Yeni Ekle
            </Button>
        </div>
    );
};

export default FinancialIncome;